module.exports = __webpack_public_path__ + "img/aa.3b28112.png";